module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAHklEQVQ4y2NgGLTgPxIgVWyQGzQa2KOBPRrYQwMAAAZHQszuyiw6AAAAAElFTkSuQmCC"